import { JobRootRecord } from "common/reducers/job.reducer";
import { currentJobId } from "common/selectors/job.selectors";
import { RootState } from "common/reducers";

export const rootKey = "screenShares";

export const activeScreenShare = (state: RootState, _props?: any) =>
  state.getIn([rootKey, "byJobId", currentJobId(state), "screenShare"]) as any;

export const activeScreenShareStatus = (state: RootState, _props?: any) =>
  state.getIn([rootKey, "byJobId", currentJobId(state), "screenShareStatus"]) as any;

export const landingLoaded = (state: RootState, _props?: any) => state.getIn([rootKey, "landingLoaded"]);

export const roomExists = (state: RootState, _props?: any) => state.getIn([rootKey, "roomExists"]);
